const META_DATA_ACTIONS = {
  GET_ALL_BRANCH_ORG: "GET_ALL_BRANCH_ORG",
};
export default META_DATA_ACTIONS;
